import {
  ATTACK_COOLDOWN_MS,
  DODGE_COOLDOWN_MS,
  DODGE_DURATION_MS,
  DODGE_INVULNERABLE_MS,
} from '@/domain/expedition/types';

export interface CombatActionClock {
  lastAttackAt: number;
  lastDodgeAt: number;
  lastSkillAt: number;
  dodgeUntil: number;
  invulnerableUntil: number;
}

export function makeCombatActionClock(): CombatActionClock {
  return {
    lastAttackAt: 0,
    lastDodgeAt: 0,
    lastSkillAt: 0,
    dodgeUntil: 0,
    invulnerableUntil: 0,
  };
}

export function canAttack(clock: CombatActionClock, nowMs: number): boolean {
  return nowMs - clock.lastAttackAt >= ATTACK_COOLDOWN_MS;
}

export function canDodge(clock: CombatActionClock, nowMs: number): boolean {
  return nowMs - clock.lastDodgeAt >= DODGE_COOLDOWN_MS;
}

export function canUseSkill(clock: CombatActionClock, nowMs: number, cooldownMs: number): boolean {
  return nowMs - clock.lastSkillAt >= cooldownMs;
}

export function isInvulnerable(clock: CombatActionClock, nowMs: number): boolean {
  return nowMs < clock.invulnerableUntil;
}

export function beginDodge(clock: CombatActionClock, nowMs: number): CombatActionClock {
  return {
    ...clock,
    lastDodgeAt: nowMs,
    dodgeUntil: nowMs + DODGE_DURATION_MS,
    invulnerableUntil: nowMs + DODGE_INVULNERABLE_MS,
  };
}
